module.exports = __webpack_public_path__ + "static/media/stw.1df97af7.png";